import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { CropwiseFinancialsLogo } from '../SvgIcons';

const PAGE_PADDING = 36;
const FOOTER_HEIGHT = 84;
const FOOTER_TOP_PADDING = 24;
const LOGO_VERTICAL_ADJUSTMENT = -4; // Aligns logo baseline with text

const styles = StyleSheet.create({
  footer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    fontSize: 8,
    paddingTop: FOOTER_TOP_PADDING
  },
  footerContainer: {
    position: 'absolute',
    left: PAGE_PADDING,
    right: PAGE_PADDING,
    bottom: 0,
    height: FOOTER_HEIGHT
  }
});

export type FooterProps = {
  copyrightText: string;
  generatedOnText: string;
  exportLanguage: string;
  fullDate: Record<string, string>;
  getPageNumberText: (pageNumber: number, totalPages: number) => string;
};

const Footer: React.FC<FooterProps> = ({
  copyrightText,
  generatedOnText,
  exportLanguage,
  fullDate,
  getPageNumberText
}) => {
  return (
    <View style={styles.footerContainer} fixed>
      <View style={styles.footer}>
        <View>
          <Text>
            {generatedOnText} {fullDate[exportLanguage]}
          </Text>
          <Text>
            {copyrightText} Syngenta {new Date().getFullYear()}
          </Text>
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end'
          }}
        >
          <View style={{ marginBottom: LOGO_VERTICAL_ADJUSTMENT }}>
            <CropwiseFinancialsLogo />
          </View>
          <Text
            render={({ pageNumber, totalPages }) =>
              getPageNumberText(pageNumber, totalPages)
            }
          />
        </View>
      </View>
    </View>
  );
};

export default Footer;
